import { Helmet } from "react-helmet";

import { SortOrder } from "@covertree/agent-portal-graphql";
import { TableView } from "@covertree/ui/table/TableView";
import formatPageTitle from "@utils/formatPageTitle";

import { useGetSequoia } from "./useGetSequoia";

export default function Sequoia() {
  const {
    loading,
    error,
    bookConversions,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetSequoia();

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Sequoia")}</title>
      </Helmet>
      <TableView
        header="Sequoia"
        loading={loading}
        error={error}
        tabs={filters}
        totalCount={totalCount}
        page={currentPage}
        rows={bookConversions}
        rowsPerPage={rowsPerPage}
        sortBy={sortBy}
        sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
        columns={columns}
        onTabChange={handleFilterChange}
        onPageChange={handleChangePage}
        onSortChange={handleSortChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
}
